/*
 * @Author: zjw
 * @Date: 2021-06-30 14:20:03
 * @LastEditTime: 2021-06-30 14:22:19
 * @FilePath: \web-app\src\common\global.js
 * @Environment: Vue + Element
 * @Description: 定义全局变量
 */

const serverSrc = 'www.weixieqingbao.com'
const token = '12345678'
const hasEnter = false
const userSite = 'on-line'
let baseImg
if (process.env.NODE_ENV === "development") { //开发环境
    baseImg = 'https://img.cdn.sky-road.net'
    // baseImg = 'http://172.28.2.12'
}else {
	baseImg = window.location.origin
}

export {
    userSite, //用户地址
    token, //用户token身份
    serverSrc, //服务器地址
    hasEnter, //用户登录状态
	baseImg
}
